// Referral reward rules (client mirror of supabase/functions/_shared/referrals.ts).
// Each friend who signs up = 1 bonus design, granted immediately. Max 12 per rolling year.
export const DESIGNS_PER_REFERRAL = 1;
export const MAX_REWARDS_PER_YEAR = 12;

/** Bonus designs earned from `signups` referrals, respecting the yearly cap. */
export const designsEarned = (signups: number) => Math.min(Math.max(0, signups) * DESIGNS_PER_REFERRAL, MAX_REWARDS_PER_YEAR);

/** Designs a user can start this month: monthly allowance left plus bonus designs. */
export const designsRemaining = (limit: number, used: number, bonus: number) => Math.max(0, limit - used) + Math.max(0, bonus);

/** Reward months still available this rolling year. */
export const rewardsLeftThisYear = (grantedLastYear: number) => Math.max(0, MAX_REWARDS_PER_YEAR - grantedLastYear);

/** A user can never refer themselves. */
export const isSelfReferral = (referrerId: string, referredId: string, referrerEmail?: string | null, referredEmail?: string | null) =>
  referrerId === referredId || (!!referrerEmail && !!referredEmail && referrerEmail.toLowerCase() === referredEmail.toLowerCase());

// --- Code captured from /r/:code, kept through sign-up (incl. OAuth redirects) ---
const KEY = "huelo_referral_code";
const TTL_MS = 7 * 24 * 3600 * 1000;

export function storeReferralCode(code: string) {
  try { localStorage.setItem(KEY, JSON.stringify({ code: code.toUpperCase(), at: Date.now() })); } catch { /* ignore */ }
}
export function getReferralCode(): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, at } = JSON.parse(raw);
    if (!code || Date.now() - at > TTL_MS) { localStorage.removeItem(KEY); return null; }
    return code;
  } catch { return null; }
}
export function clearReferralCode() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
